import SeasonalityChartEventLine from '@page-components/condensed-timeline/sales-forecast/SeasonalityChartEventLine';
import { DateUtility } from '@utility/date';
import {
  chartDisplayDate,
  colors,
  parseDate,
  referenceLineOptions,
} from '@utility/sales-forecast';
import { Fragment } from 'react';
import { Label, ReferenceArea, ReferenceLine } from 'recharts';

/**
 * SeasonalityChartDeals component displaying lightning deal dates and related visuals.
 * @param {string[]} props.lightningDealDates - Array of lightning deal dates.
 * @param {Object[]} props.lightningDeal - Array of lightning deal objects.
 * @param {string} props.eventId - The ID of the current event.
 * @param {Function} props.setEventId - Function to set the event ID.
 * @returns {JSX.Element[]} React component rendering lightning deal dates and visuals.
 *
 * @see {@link https://recharts.org/en-US/api/ReferenceLine | ReferenceLine Documentation}
 * @see {@link https://recharts.org/en-US/api/ReferenceArea | ReferenceArea Documentation}
 */
function SeasonalityChartDeals(props) {
  const { lightningDealDates, lightningDeal, eventId, setEventId } = props;

  return (
    <>
      {lightningDealDates.map(d => {
        // Find Data
        const selected = lightningDeal.find(c => parseDate(c.from) === d);

        // Event Selected -> Force Render Area
        const opacity = eventId && eventId === selected._id ? '1' : '0';

        let fixedDate = d;

        if (DateUtility.isDateAfter(new Date(), d)) {
          fixedDate = new Date();
        }

        const xAxisId = chartDisplayDate(fixedDate);

        return (
          <Fragment key={`lightningDealDates-${d}`}>
            {/* Reference line for lightning deal */}
            <ReferenceLine
              x={xAxisId}
              {...referenceLineOptions}
              stroke={colors.lightningDeal.background}
              label={
                <Label
                  x={xAxisId}
                  content={
                    <SeasonalityChartEventLine
                      position="right"
                      isSeasonal={false}
                      setEventId={setEventId}
                      eventId={eventId}
                    />
                  }
                  // @ts-expect-error - TS2322: Type '{ x: string; content: Element; data: any; }' is not assignable to type 'In...
                  data={selected}
                />
              }
            />

            {/* Reference area for lightning deal */}
            <ReferenceArea
              animationDuration={150}
              fill={colors.lightningDeal.font}
              fillOpacity={0.1}
              id={`event-${selected._id}`}
              ifOverflow="visible"
              isFront
              style={{ opacity }}
              x1={xAxisId}
              x2={chartDisplayDate(selected.to)}
            />
          </Fragment>
        );
      })}
    </>
  );
}

export default SeasonalityChartDeals;
